
import '../styles/app.scss';

window.easings = {};
window.easings.ease = "cubicBezier(0.25, 0.46, 0.45, 0.94)";
window.easings.andrew = "cubicBezier(0.77, 0, 0.175, 1)";
window.easings.feebles1 = "cubicBezier(.8,.03,.25,1)";
window.easings.feebles2 = "cubicBezier(.72,.01,.25,1)";
window.easings.ease2 = "cubicBezier(.48,.1,.48,.9)";

// Getting our breakpoint for javascript
window.Breakpoint = {};

Breakpoint.refreshValue = function(){
  this.value = window.getComputedStyle(document.querySelector('body'), ':before').getPropertyValue('content').replace(/\"/g, '');
};

$(window).resize(function(){ Breakpoint.refreshValue(); }).resize();


// Libs
import PubSub from "underpub-js";
import Sitewide from "./classes/Sitewide";
import ComponentsLoader from "./classes/ComponentsLoader";

// Components Import -- DO NOT REMOVE COMMENT!
import ListingInfoSlider from "../components/molecules/Listing/ListingInfoSlider/ListingInfoSlider";
import VideoImageTwoUp from "../components/molecules/Video/VideoImageTwoUp/VideoImageTwoUp";
import ImageLinkCard from "../components/elements/ImageLinkCard/ImageLinkCard";
import IframeEmbed from "../components/molecules/Misc/IframeEmbed/IframeEmbed";
import CtaContactLinks from "../components/molecules/Cta/CtaContactLinks/CtaContactLinks";
import ContactInfo from "../components/molecules/Misc/ContactInfo/ContactInfo";
import ListingOpenPositions from "../components/molecules/Listing/ListingOpenPositions/ListingOpenPositions";
import ListingTwoProjectsStaggered from "../components/molecules/Listing/ListingTwoProjectsStaggered/ListingTwoProjectsStaggered";
import HeroPersonDetail from "../components/molecules/Hero/HeroPersonDetail/HeroPersonDetail";
import CtaTextWithImage from "../components/molecules/Cta/CtaTextWithImage/CtaTextWithImage";
import VideoFullWidth from "../components/molecules/Video/VideoFullWidth/VideoFullWidth";
import ContentBasic from "../components/molecules/Content/ContentBasic/ContentBasic";
import HeroArticleDetail from "../components/molecules/Hero/HeroArticleDetail/HeroArticleDetail";
import SearchFormSmall from "../components/molecules/Search/SearchFormSmall/SearchFormSmall";
import ListingThreeUpPeople from "../components/molecules/Listing/ListingThreeUpPeople/ListingThreeUpPeople";
import LayoutPeoplePage from "../components/layouts/LayoutPeoplePage/LayoutPeoplePage";
import ListingInsightCards from "../components/molecules/Listing/ListingInsightCards/ListingInsightCards";
import LayoutInsightsPage from "../components/layouts/LayoutInsightsPage/LayoutInsightsPage";
import ContentTwoImagesStaggered from "../components/molecules/Content/ContentTwoImagesStaggered/ContentTwoImagesStaggered";
import ListingThreeUpPracticeAreas from "../components/molecules/Listing/ListingThreeUpPracticeAreas/ListingThreeUpPracticeAreas";
import ProjectIndex from "../components/molecules/Misc/ProjectIndex/ProjectIndex";
import Filters from "../components/molecules/Misc/Filters/Filters";
import HeroText from "../components/molecules/Hero/HeroText/HeroText";
import LayoutProjectIndexPage from "../components/layouts/LayoutProjectIndexPage/LayoutProjectIndexPage";
import ImageTwoUpImages from "../components/molecules/Image/ImageTwoUpImages/ImageTwoUpImages";
import ImageFullWidth from "../components/molecules/Image/ImageFullWidth/ImageFullWidth";
import HeroTextWithInfoItems from "../components/molecules/Hero/HeroTextWithInfoItems/HeroTextWithInfoItems";
import ImageSliderFullWidth from "../components/molecules/Image/ImageSliderFullWidth/ImageSliderFullWidth";
import CtaNewsletterSignup from "../components/molecules/Cta/CtaNewsletterSignup/CtaNewsletterSignup";
import Breadcrumb from "../components/elements/Breadcrumb/Breadcrumb";
import HeroTextWithFilterLinks from "../components/molecules/Hero/HeroTextWithFilterLinks/HeroTextWithFilterLinks";
import LayoutProjectsPage from "../components/layouts/LayoutProjectsPage/LayoutProjectsPage";
import ContentSimpleTextContent from "../components/molecules/Content/ContentSimpleTextContent/ContentSimpleTextContent";
import Pagination from "../components/elements/Pagination/Pagination";
import ButtonLinks from "../components/molecules/Misc/ButtonLinks/ButtonLinks";
import ListingFourUpPeople from "../components/molecules/Listing/ListingFourUpPeople/ListingFourUpPeople";
import ListingThreeUpImageLinkItems from "../components/molecules/Listing/ListingThreeUpImageLinkItems/ListingThreeUpImageLinkItems";
import ButtonOutline from "../components/atoms/ButtonOutline/ButtonOutline";
import SearchFilters from "../components/molecules/Search/SearchFilters/SearchFilters";
import SearchForm from "../components/molecules/Search/SearchForm/SearchForm";
import LayoutSearchPage from "../components/layouts/LayoutSearchPage/LayoutSearchPage";
import Footer from "../components/molecules/Footer/Footer/Footer";
import ButtonPill from "../components/atoms/ButtonPill/ButtonPill";
import CtaFullWidthBgImage from "../components/molecules/Cta/CtaFullWidthBgImage/CtaFullWidthBgImage";
import CtaTwoUpImageLinkItems from "../components/molecules/Cta/CtaTwoUpImageLinkItems/CtaTwoUpImageLinkItems";
import ListingCardSlider from "../components/molecules/Listing/ListingCardSlider/ListingCardSlider";
import BackgroundImageCard from "../components/elements/BackgroundImageCard/BackgroundImageCard";
import Cursor from "../components/atoms/Cursor/Cursor";
import ListingOneUpProject from "../components/molecules/Listing/ListingOneUpProject/ListingOneUpProject";
import ButtonLine from "../components/atoms/ButtonLine/ButtonLine";
import ImageLinkItem from "../components/elements/ImageLinkItem/ImageLinkItem";
import ListingTwoUpProjects from "../components/molecules/Listing/ListingTwoUpProjects/ListingTwoUpProjects";
import ContentIntroWithLink from "../components/molecules/Content/ContentIntroWithLink/ContentIntroWithLink";
import ButtonArrow from "../components/atoms/ButtonArrow/ButtonArrow";
import HeroImageSlider from "../components/molecules/Hero/HeroImageSlider/HeroImageSlider";
import NavOverlay from "../components/molecules/Navigation/NavOverlay/NavOverlay";
import NavBar from "../components/molecules/Navigation/NavBar/NavBar";
import FullWidthVideoAutoplay from "../components/molecules/Video/FullWidthVideoAutoplay/FullWidthVideoAutoplay";

$(document).ready(function(){

  var components = [
    // Components Loader -- DO NOT REMOVE COMMENT!
{handle: ".comp-ListingInfoSlider", require: ListingInfoSlider },
{handle: ".comp-VideoImageTwoUp", require: VideoImageTwoUp },
{handle: ".el-ImageLinkCard", require: ImageLinkCard },
{handle: ".comp-IframeEmbed", require: IframeEmbed },
{handle: ".comp-CtaContactLinks", require: CtaContactLinks },
{handle: ".comp-ContactInfo", require: ContactInfo },
{handle: ".comp-ListingOpenPositions", require: ListingOpenPositions },
{handle: ".comp-ListingTwoProjectsStaggered", require: ListingTwoProjectsStaggered },
{handle: ".comp-HeroPersonDetail", require: HeroPersonDetail },
{handle: ".comp-CtaTextWithImage", require: CtaTextWithImage },
{handle: ".comp-VideoFullWidth", require: VideoFullWidth },
{handle: ".comp-ContentBasic", require: ContentBasic },
{handle: ".comp-HeroArticleDetail", require: HeroArticleDetail },
{handle: ".comp-SearchFormSmall", require: SearchFormSmall },
{handle: ".comp-ListingThreeUpPeople", require: ListingThreeUpPeople },
{handle: ".layout-LayoutPeoplePage", require: LayoutPeoplePage },
{handle: ".comp-ListingInsightCards", require: ListingInsightCards },
{handle: ".layout-LayoutInsightsPage", require: LayoutInsightsPage },
{handle: ".comp-ContentTwoImagesStaggered", require: ContentTwoImagesStaggered },
{handle: ".comp-ListingThreeUpPracticeAreas", require: ListingThreeUpPracticeAreas },
{handle: ".comp-ProjectIndex", require: ProjectIndex },
{handle: ".comp-Filters", require: Filters },
{handle: ".comp-HeroText", require: HeroText },
{handle: ".layout-LayoutProjectIndexPage", require: LayoutProjectIndexPage },
{handle: ".comp-ImageTwoUpImages", require: ImageTwoUpImages },
{handle: ".comp-ImageFullWidth", require: ImageFullWidth },
{handle: ".comp-HeroTextWithInfoItems", require: HeroTextWithInfoItems },
{handle: ".comp-ImageSliderFullWidth", require: ImageSliderFullWidth },
{handle: ".comp-CtaNewsletterSignup", require: CtaNewsletterSignup },
{handle: ".el-Breadcrumb", require: Breadcrumb },
{handle: ".comp-HeroTextWithFilterLinks", require: HeroTextWithFilterLinks },
{handle: ".layout-LayoutProjectsPage", require: LayoutProjectsPage },
{handle: ".comp-ContentSimpleTextContent", require: ContentSimpleTextContent },
{handle: ".el-Pagination", require: Pagination },
{handle: ".comp-ButtonLinks", require: ButtonLinks },
{handle: ".comp-ListingFourUpPeople", require: ListingFourUpPeople },
{handle: ".comp-ListingThreeUpImageLinkItems", require: ListingThreeUpImageLinkItems },
{handle: ".atom-ButtonOutline", require: ButtonOutline },
{handle: ".comp-SearchFilters", require: SearchFilters },
{handle: ".comp-SearchForm", require: SearchForm },
{handle: ".layout-LayoutSearchPage", require: LayoutSearchPage },
{handle: ".comp-Footer", require: Footer },
{handle: ".atom-ButtonPill", require: ButtonPill },
{handle: ".comp-CtaFullWidthBgImage", require: CtaFullWidthBgImage },
{handle: ".comp-CtaTwoUpImageLinkItems", require: CtaTwoUpImageLinkItems },
{handle: ".comp-ListingCardSlider", require: ListingCardSlider },
{handle: ".el-BackgroundImageCard", require: BackgroundImageCard },
{handle: ".atom-Cursor", require: Cursor },
{handle: ".comp-ListingOneUpProject", require: ListingOneUpProject },
{handle: ".atom-ButtonLine", require: ButtonLine },
{handle: ".el-ImageLinkItem", require: ImageLinkItem },
{handle: ".comp-ListingTwoUpProjects", require: ListingTwoUpProjects },
{handle: ".comp-ContentIntroWithLink", require: ContentIntroWithLink },
{handle: ".atom-ButtonArrow", require: ButtonArrow },
{handle: ".comp-HeroImageSlider", require: HeroImageSlider },
{handle: ".comp-NavOverlay", require: NavOverlay },
{handle: ".comp-NavBar", require: NavBar },
{handle: ".comp-FullWidthVideoAutoplay", require: FullWidthVideoAutoplay },
  ];

  var sitewide = new Sitewide();
  sitewide.init();

  // Getting our components loading going
  var componentsLoader = new ComponentsLoader({components: components});
  componentsLoader.initScreen();

  // setting our breakpoint value
  Breakpoint.refreshValue();

});
